import type { Link } from '@repo/sdk/gen'

export const LINK_KINDS = ['all', 'download', 'upload'] as const

export const LINK_VIEWS = ['live', 'expired', 'revoked', 'all'] as const

/**
 * What a list of links can show, as one choice rather than a switch with a
 * filter appearing behind it (OPSSTD-8807) — and the `state` query each one
 * asks the listing for. `all` asks for none, which the endpoints read as every
 * state. Shared by `/links` and `/admin/links`, which open on the same view for
 * the same reason.
 *
 * **`live` is the default and carries two states.** It is the links still
 * standing for whoever holds them: `active`, and `policy_blocked` — while the
 * organization has links off every surviving link reads `policy_blocked`, and
 * it resumes on its own once they are back on, so leaving it out would empty
 * the page exactly when its owner wants to know what happened to their links.
 * For the same reason `policy_blocked` is no view of its own: it is the
 * organization's switch, not a per-link condition, so on its own it selects
 * "all of them" or "none of them".
 */
export const LINK_VIEW_STATES = {
	live: ['active', 'policy_blocked'],
	expired: ['expired'],
	revoked: ['revoked'],
	all: undefined
} as const satisfies Record<
	(typeof LINK_VIEWS)[number],
	readonly Link['state'][] | undefined
>
